var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count-places"},[_c('div',{staticClass:"text-bold q-mr-md"},[_vm._v(_vm._s(_vm.country.name))]),_c('div',{staticClass:"text-grey-6"},[_vm._v(_vm._s(_vm.countText))])])}
var staticRenderFns = []

export { render, staticRenderFns }